<!--
  Bloco da nota NSTech no painel Status integrações (TMS-7222, A3 e A6).

  Componente de APRESENTAÇÃO, no molde de `OcorrenciaIntegracaoErro.vue`: recebe
  props, emite eventos, não faz HTTP e não consulta permissão. A view continua
  dona do POST, do `ReturnApi` e de `getPermissionFw`.

  1. Sem `motivo`, sem `reenvio_permitido === true` e sem `em_processamento_desde`
     (backend antigo, nota sem problema) o componente renderiza NADA — a célula
     fica idêntica a hoje. Nota nunca despachada (sem `motivo`, mas com
     `reenvio_permitido`) mostra o título "não enviada" e o botão (I-4).
  2. Todo texto vindo da NSTech (`motivo`, `orientacao`) sai por `{{ }}`. NUNCA
     `v-html`, em lugar nenhum deste arquivo: é resposta crua de sistema externo.
  3. O botão só existe com `reenvio_permitido === true` E `podeReenviar` (permissão
     resolvida pela view). Quem autoriza de verdade é o endpoint.
  4. Com `reenvio_em_andamento === true` (job de reenvio em voo) o botão fica
     desabilitado e diz "Reenvio em andamento…": antes ele voltava a ficar ativo assim
     que a API respondia 202 e o operador clicava de novo achando que não tinha ido.
-->
<template>
  <div v-if="temConteudo" class="nstech-nota-recusa">
    <template v-if="mostraCabecalho">
      <strong class="d-block text-danger">{{ titulo }}</strong>

      <template v-if="mostraMotivo">
        <small class="d-block text-danger">{{ item.motivo }}</small>
        <small v-if="item.orientacao" class="d-block text-danger">{{
          item.orientacao
        }}</small>
      </template>

      <div v-if="mostraBotao" class="mt-1">
        <button
          type="button"
          class="btn btn-sm btn-primary mr-1 mb-1"
          :disabled="reenviando || emAndamento"
          @click="$emit('reenviar', item.docfis_id)"
        >
          {{ rotuloDoBotao }}
        </button>
      </div>

      <div v-if="detalhes.length > 0">
        <button
          type="button"
          class="btn btn-link btn-sm p-0"
          :aria-controls="collapseId"
          :aria-expanded="aberto ? 'true' : 'false'"
          @click="aberto = !aberto"
        >
          <i
            class="fa"
            :class="aberto ? 'fa-caret-down' : 'fa-caret-right'"
            aria-hidden="true"
          ></i>
          {{ rotuloDetalhes }}
        </button>
        <b-collapse :id="collapseId" v-model="aberto">
          <dl class="row mb-0 small text-muted">
            <template v-for="(detalhe, indice) in detalhes">
              <dt :key="`${collapseId}-rotulo-${indice}`" class="col-5">
                {{ detalhe.rotulo }}
              </dt>
              <dd :key="`${collapseId}-valor-${indice}`" class="col-7">
                {{ detalhe.valor }}
              </dd>
            </template>
          </dl>
        </b-collapse>
      </div>
    </template>

    <small v-if="emAndamento && !mostraBotao" class="d-block text-muted">{{
      rotuloEmAndamento
    }}</small>

    <small v-if="espera" class="d-block text-muted">{{ espera }}</small>
  </div>
</template>

<script>
import {
  ACAO_REENVIANDO,
  ACAO_REENVIAR,
  ACAO_REENVIO_EM_ANDAMENTO,
  DETALHES_ROTULO,
} from "../constants/nstechNotaCopy";
import {
  detalhesDaNota,
  deveRenderizarNota,
  podeReenviarNota,
  reenvioEmAndamento,
  temMotivo,
  textoDeEspera,
  tituloDaNota,
} from "../utils/nstechNotaEstado";

export default {
  name: "NstechNotaRecusa",

  props: {
    /** Linha NSTech do painel (snake_case), com os campos aditivos do ADR-0014. */
    item: {
      type: Object,
      required: true,
    },
    cargaId: {
      type: [Number, String],
      default: null,
    },
    /** SÓ permissão (`getPermissionFw('expedicao.store')`), resolvida pela view. */
    podeReenviar: {
      type: Boolean,
      default: false,
    },
    /** A view marca a nota em reenvio para bloquear clique duplo. */
    reenviando: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      aberto: false,
      rotuloReenviar: ACAO_REENVIAR,
      rotuloReenviando: ACAO_REENVIANDO,
      rotuloEmAndamento: ACAO_REENVIO_EM_ANDAMENTO,
      rotuloDetalhes: DETALHES_ROTULO,
    };
  },

  computed: {
    mostraMotivo() {
      return temMotivo(this.item);
    },

    titulo() {
      return tituloDaNota(this.item);
    },

    mostraBotao() {
      return this.podeReenviar && podeReenviarNota(this.item);
    },

    /** Job de reenvio desta nota em voo (campo `reenvio_em_andamento` do back). */
    emAndamento() {
      return reenvioEmAndamento(this.item);
    },

    rotuloDoBotao() {
      if (this.reenviando) {
        return this.rotuloReenviando;
      }

      return this.emAndamento ? this.rotuloEmAndamento : this.rotuloReenviar;
    },

    detalhes() {
      return detalhesDaNota(this.item, this.cargaId);
    },

    /** Calculado na renderização: reflete o "agora" a cada recarga do painel. */
    espera() {
      return textoDeEspera(this.item.em_processamento_desde, new Date());
    },

    /** Título + botão: há motivo OU a nota pode ser reenviada (nunca despachada). */
    mostraCabecalho() {
      return this.mostraMotivo || this.mostraBotao;
    },

    temConteudo() {
      return deveRenderizarNota(this.item, new Date());
    },

    collapseId() {
      const id = this.item.docfis_id != null ? this.item.docfis_id : this._uid;

      return `nstech-nota-detalhes-${this.cargaId}-${id}`;
    },
  },
};
</script>
